import BillingsTaxiTaxiUpdateStatusParams from "../../../../../common/services/billings/taxi-taxi/update-status/billings-taxi-taxi-update-status-params";
import BillingStatus from "../../../../../common/types/billing-status";
import { ActionOption } from "../types/action-option";

const createUpdateBillingStatusRequest = (
  billingUuid: string,
  actionOption: ActionOption,
  comment: string,
): BillingsTaxiTaxiUpdateStatusParams => {
  return {
    billingUuid: billingUuid,
    comment: comment,
    status: setBillingStatus(actionOption),
  };
};

const setBillingStatus = (action: ActionOption): BillingStatus => {
  switch (action) {
    case ActionOption.ACCEPT:
      return BillingStatus.ACCEPTED;
    case ActionOption.REJECT:
      return BillingStatus.REJECTED;
    case ActionOption.REOPEN:
      return BillingStatus.REOPENED;
    case ActionOption.SEND_REQUEST_TO_REOPEN:
      return BillingStatus.REOPEN_REQUEST;
  }
};

const billingStatusUpdateRequestFactory = {
  createUpdateBillingStatusRequest,
};

export default billingStatusUpdateRequestFactory;
